(function () {
function $965533ac84b5bf59$export$2e2bcd8739ae039() {
    const accordionsCooontainer = document.querySelectorAll("[js-accordion-container]");
    if (!accordionsCooontainer) return;
    accordionsCooontainer.forEach((container)=>{
        container.addEventListener("click", handleClick);
        function handleClick(e) {
            const target = e.target;
            const title = target.classList.contains(".accordion-title") || target.closest(".accordion-title");
            if (title) {
                const attrParent = title.getAttribute(`js-comentario-parent`);
                if (attrParent) //parent accordion
                document.querySelectorAll(`.accordion-title[js-comentario-parent="${attrParent}"]`).forEach((i)=>{
                    if (i !== title) {
                        if (i.closest(".accordion-item").classList.contains("active")) i.click();
                    }
                });
                const idAccordion = title.getAttribute("data-accordion");
                const content = container.querySelector(`.accordion-content[data-accordion="${idAccordion}"]`);
                const contentDiv = container.querySelector(`.accordion-content[data-accordion="${idAccordion}"] > div `);
                const pai = content.parentElement.closest(".accordion-content");
                const height = content.scrollHeight;
                title.closest(".accordion-item").classList.toggle("active");
                content.classList.toggle("active");
                let isChildren = content.hasAttribute("js-accordion-child");
                if (isChildren && content.classList.contains("active")) {
                    gsap.set(pai, {
                        height: "auto"
                    });
                    return;
                }
                if (content.classList.contains("active")) gsap.fromTo(content, {
                    height: 0
                }, {
                    height: height,
                    duration: 0.3
                });
                else gsap.fromTo(content, {
                    height: height
                }, {
                    height: 0,
                    duration: 0.3
                });
            }
        }
    });
}


function $33e222e22d670651$export$2e2bcd8739ae039() {
    const attr = "[js-breadcrumb]";
    const breadcrumb = document.querySelector(`.breadcrumb${attr}`);
    const objStr = breadcrumb?.dataset.obj;
    console.log(objStr);
    if (!breadcrumb || !objStr) return;
    const obj = JSON.parse(objStr.replaceAll(`'`, `"`));
    const aLength = obj.length - 1;
    const items = obj.map(({ name: name, slug: slug, link: link }, index)=>`
		<li class="${index === aLength ? "active" : ""}">
			<a ${link ? `href="${link}"` : ""} data-slug="${slug}">${name}</a>
		</li>
		`);
    const template = ()=>{
        return `
			<ul class="flex flex-wrap breadcrumb-wrapper">
				<li>
					<a href="/">
							Home
					</a>
				</li>
				${items.join("")}
			</ul>
		`;
    };
    breadcrumb.innerHTML = template();
    if (GLOBAL.isMobile) {
        const breadMobile = document.querySelector(".breadcrumb-mobile");
        breadMobile.appendChild(breadcrumb);
    }
}


function $f231b21555063952$export$2e2bcd8739ae039() {
    document.querySelectorAll("table[js-dataTables]")?.forEach((t)=>{
        const props = t.dataset.props || {};
        const Dtable = $(t).DataTable({
            "language": {
                "show": "Visualizar",
                "lengthMenu": "Mostrar _MENU_ linhas por p\xe1gina",
                "zeroRecords": "Nada encontrado",
                "info": "Exibindo p\xe1gina _PAGE_ de _PAGES_",
                "infoEmpty": "Nada encontrado",
                "infoFiltered": "(filtrado de _MAX_ no total)",
                "search": "Pesquisar",
                "paginate": {
                    "previous": "Anterior",
                    "next": "Pr\xf3xima"
                }
            },
            "autoWidth": true,
            "ordering": true,
            "order": [
                [
                    0,
                    "desc"
                ]
            ],
            // rowReorder: {
            //     selector: 'td:nth-child(2)'
            // },
            select: {
                items: "cell"
            },
            responsive: true,
            paginate: false,
            search: false,
            info: false,
            ...props
        });
        GLOBAL.wrap_single(t, "div", [
            "table-container"
        ]);
    // t.querySelectorAll("thead th")
    // 	?.forEach(t => t.addEventListener("click", () => {
    // 		Dtable.columns.adjust().draw();
    // 	}))
    });
}


function $f83e4df3492bfdfc$export$2e2bcd8739ae039(element, events, callback) {
    const outside = "data-outside";
    const html = document.documentElement;
    if (!element.hasAttribute(outside)) {
        events.forEach((userEvent)=>{
            html.addEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
            ;
        });
        element.setAttribute(outside, "") //coloca atributo para nao adicionar o evento mais de uma vez
        ;
    }
    function handleOutsideClick(event) {
        if (!element.contains(event.target)) {
            element.removeAttribute(outside, "");
            events.forEach((userEvent)=>{
                html.removeEventListener(userEvent, handleOutsideClick) //adiciona evento de click que vai aproveitar do bubble
                ;
            });
            callback();
        }
    }
}


function $f96a0b47b65ca3bd$export$2e2bcd8739ae039() {
    const dropdownMenus = document.querySelectorAll("[js-dropdown]");
    dropdownMenus.forEach((menu)=>{
        [
            "touchstart",
            "click"
        ].forEach((userEvent)=>{
            menu.addEventListener(userEvent, handleClick);
        });
    });
    function handleClick(event) {
        // event.preventDefault(); //retirar se tiver click no item
        dropdownMenus.forEach((i)=>i.classList.remove("active"));
        this.classList.add("active");
        // outside click pode ser reaproveitado para outros eventos de bubble
        (0, $f83e4df3492bfdfc$export$2e2bcd8739ae039)(this, [
            "touchstart",
            "click",
            "mouseleave"
        ], ()=>{
            this.classList.remove("active");
        });
    }
}


function $d1667b4cd6b81e3c$export$2e2bcd8739ae039() {
    const hasInlines = document.querySelector("[data-js-inline]");
    if (!hasInlines) return;
    function addRemoveEventInExistingInlines() {
        const btnsRemoveInline = document.querySelectorAll("[class*='remove_inline']");
        btnsRemoveInline.forEach((btn)=>{
            const inline = btn.closest(".inline-item");
            btn.addEventListener("click", ()=>removeInline(inline));
        });
    }
    function checkMaxNumAllForms() {
        const maxNumbersElements = document.querySelectorAll("[id$='-MAX_NUM_FORMS']");
        maxNumbersElements.forEach((numberElement)=>{
            const wrapperInline = numberElement.closest(".wrapper-inline");
            checkMaxNumForm(numberElement.value, wrapperInline);
        });
    }
    function checkMaxNumForm(totalForms, wrapperInline) {
        const inlineItens = wrapperInline.querySelectorAll(".inline-item");
        if (inlineItens.length === Number(totalForms)) {
            const dataJsInline = wrapperInline.dataset.jsInline;
            const btnAddInline = document.querySelector(`.add_inline[data-js-inline='${dataJsInline}']`);
            btnAddInline.classList.add("hidden");
        }
    }
    function addAddEventInExistingInlines() {
        const btnsAddInline = document.querySelectorAll(".add_inline");
        btnsAddInline && btnsAddInline.forEach((btnAddInline)=>{
            //o id já vir acrescentado do outro
            btnAddInline.addEventListener("click", ()=>addInline(btnAddInline.dataset.jsInline));
        });
    }
    function addInline(dataJsInline) {
        const wrapperInline = document.querySelector(`.wrapper-inline[data-js-inline='${dataJsInline}']`);
        const inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        const inputFormIndex = wrapperInline.querySelector("[id$='-TOTAL_FORMS']");
        const intFormIndex = parseInt(inputFormIndex.value);
        const emptyForm = $(`.empty_inline_form[data-js-inline='${dataJsInline}']`);
        $(wrapperInline).append(emptyForm.html().replace(/__prefix__/g, intFormIndex));
        const removeBtn = wrapperInline.querySelector(`.remove_inline-${intFormIndex}`);
        const inline = document.querySelector(`.inline-${intFormIndex}[data-js-inline=${dataJsInline}]`);
        removeBtn.addEventListener("click", ()=>removeInline(inline));
        inputFormIndex.value = intFormIndex + 1;
        extraConfigs(inline, intFormIndex);
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function removeInline(inline) {
        const wrapperInline = inline.closest(".wrapper-inline");
        const inputMaxForms = wrapperInline.querySelector("[id$='-MAX_NUM_FORMS']");
        const deleteBtn = inline.querySelector(`[id$='-DELETE'`);
        deleteBtn.setAttribute("checked", true);
        inline.classList.add("hidden");
        checkMaxNumForm(inputMaxForms.value, wrapperInline);
    }
    function extraConfigs(inline, id) {
        initInlineAccordion(inline, id);
        initChoices(inline);
    }
    function initChoices(inline) {
        const selects = [
            ...inline.querySelectorAll("select")
        ];
        const props = {
            searchEnabled: false,
            searchChoices: false
        };
        const outrosChoices = selects.map((select)=>GLOBAL.initChoices(select, props));
        window.listOfChoices = [
            ...listOfChoices,
            ...outrosChoices
        ];
    }
    // let count = 1000;
    function initInlineAccordion(inline, id) {
        const accordionsItem = inline.querySelectorAll(".accordion[js-accordion-container]");
        const inlineAccordions = inline.querySelectorAll("[data-accordion]");
        const accordionsTitle = inline.querySelectorAll(".accordion-title .texto");
        accordionsTitle.forEach((i)=>i.innerText = `Item n\xb0${id}`);
        inlineAccordions?.forEach((i)=>i.setAttribute("data-accordion", id));
    // window.initAccordion(accordionsItem, id);
    }
    (function init() {
        addAddEventInExistingInlines();
        addRemoveEventInExistingInlines();
        checkMaxNumAllForms();
    })();
}


function $97753764ffa51793$export$2e2bcd8739ae039() {
    //seta em todos esses tipos de input a classe active
    // se tiver length
    const attr = "[js-ativo]";
    const type = `
	input[type='text']${attr}, 
	input[type='number']${attr}, 
	input[type='email']${attr},
	textarea${attr}
	`;
    const inputs = document.querySelectorAll(type);
    // console.log('inputs', inputs)
    inputs?.forEach((input)=>input.addEventListener("change", (event)=>{
            const input = event.currentTarget;
            input.value.length !== 0 ? input.classList.add("active") : input.classList.remove("active");
        }));
}


function $a6fa111a019cef8a$export$2e2bcd8739ae039(obj) {
    let state = {
        open: false,
        delay: 150
    };
    const { isTablet: isTablet, debounceFunction: debounceFunction } = GLOBAL;
    const sidebar = document.querySelector(".sidebar");
    if (!sidebar) return false;
    const sideBarOptions = document.querySelector(".opcoes-container");
    const body = document.body;
    const svgAdicionar = `<svg><use xlink:href="#icon_add"></use></svg>`;
    const svgList = `<svg><use xlink:href="#icon_list"></use></svg>`;
    const svgArrow = `<svg class="icon group-hover:opacity-100 icon-arrow"><use xlink:href="#icon_arrow_left"></use></svg>`;
    const iconBack = `<svg class="icon-back group-hover:opacity-100 icon-arrow h-32 w-32"><use xlink:href="#icon_back_arrow"></use></svg>`;
    const tipyAdicionar = 'data-tippy-content="Adicionar"';
    const tipyList = 'data-tippy-content="Lista"';
    const fundo = document.querySelector(".nav-fundo ");
    const itensLV0 = sidebar.querySelectorAll("[js-menu-lista] > li[js-lista-name] ");
    const toogle = document.querySelector("[js-menu-toggle]");
    // Titulo
    const templateModuleName = (name, icon)=>`<li class='module-name'>${icon && !isTablet ? icon.outerHTML : ""} ${isTablet ? iconBack : ""}  ${name}<li>`;
    // Me de o menu pertencente
    const getStaticMenu = (slug)=>{
        return document.querySelector(`[js-menu-lista] [js-lista-name='${slug}']`);
    };
    // Popula os leveis do menu
    const populateMenuLevel = (itemMenu, submenu, name, svg)=>{
        const templateSubMenu = templateLevelMenu(submenu);
        const templateItems = submenu.items.map(templateItensSubmenu);
        templateSubMenu.innerHTML = templateItems.join("");
        templateSubMenu.insertAdjacentHTML("afterbegin", templateModuleName(name, svg));
        itemMenu.appendChild(templateSubMenu);
        itemMenu.classList.add("have-submenu");
    };
    // Template das liZ	
    const templateItensSubmenu = (item)=>{
        const { name: name, link: link, list: list, adicionar: adicionar, slug: slug, submenu: submenu } = item;
        // console.log(item)
        return `
				<li class="group" js-lista-name='${slug}' ${submenu ? `data-submenu` : ""}>
					<div class="item-wrapper">
						<a ${link ? `href="${link}"` : ""} class='item'> ${name}	</a>
						${adicionar ? `<a ${tipyAdicionar} class='adicionar' href="${adicionar}">${svgAdicionar}</a>` : ""}
						${list ? `<a ${tipyList} class='lista' href="${list}">${svgList}</a>` : ""}
						${submenu ? svgArrow : ""}
					</div>
				</li>`;
    };
    // Template dos sublevel
    const templateLevelMenu = (submenu)=>{
        const div = document.createElement("ul");
        div.setAttribute("data-level", submenu.level);
        div.classList.add("submenu");
        return div;
    };
    //Cria subMenus
    const createSubMenus = ({ slug: slug, submenu: submenu, name: name })=>{
        // console.log(slug)
        const itemMenu1 = getStaticMenu(slug);
        const svg = itemMenu1.querySelector("svg").cloneNode(true);
        svg.style.setProperty("--cor-1", "white");
        if (!submenu) return;
        populateMenuLevel(itemMenu1, submenu, name, svg);
        submenu.items.forEach(({ slug: slug, submenu: submenu, name: name })=>{
            const itemMenu2 = getStaticMenu(slug);
            if (!submenu) return;
            populateMenuLevel(itemMenu2, submenu, name);
            submenu.items.forEach(({ slug: slug, submenu: submenu, name: name })=>{
                const itemMenu3 = getStaticMenu(slug);
                if (!submenu) return;
                populateMenuLevel(itemMenu3, submenu, name);
            });
        });
    };
    const handleClickFundo = ()=>{
        itensLV0.forEach((i)=>i.classList.remove("active"));
        body.classList.remove("menu-ativo");
        toogleMenu();
    };
    const handleClickItem = (i)=>(e)=>{
            //e.preventDefault()
            setTimeout(()=>sidebar.classList.add("animou"), 200) //add classe para animar apenas uma vez
            ;
            body.classList.add("menu-ativo") //add classe para mostrar o fundo do menu
            ;
            itensLV0.forEach((i)=>i.classList.remove("active")) //remove ativo tds outros
            ;
            body.classList.remove("dont-open-submenu") // remove a classe que impede que o submenu seja aberto
            ;
            i.classList.toggle("active");
        };
    const toogleMenu = ()=>{
        //funcao do jquery que me da mais certeza c o menu esta aberto ou n
        if (!isTablet) {
            if (body.classList.contains("menu-ativo")) return;
            state.open = !$(sidebar).is(":hover");
        }
        // console.log(state.open);
        if (state.open) {
            body.classList.add("menu-closed");
            body.classList.add("dont-open-submenu");
            sidebar.classList.remove("animou");
            sideBarOptions.classList.remove("ativar");
            if (isTablet) {
                state.open = false;
                body.classList.remove("menu-ativo");
            }
        } else {
            body.classList.remove("menu-closed");
            body.classList.remove("menu-ativo");
            if (isTablet) state.open = true;
        }
    };
    // const showLevelActive = (e) => {
    // 	const level = Number(e.target.closest(".have-submenu")?.querySelector(".submenu").dataset.level) + 1
    // 	console.log(level);
    // 	if (level === 3) sidebar.setAttribute("data-radius", "3")
    // 	if (level === 2) sidebar.setAttribute("data-radius", "2")
    // 	if (level === 1) sidebar.setAttribute("data-radius", "1")
    // }
    const backLevel = (e)=>{
        setTimeout(()=>itensLV0.forEach((i)=>i.classList.remove("active")), 100);
    };
    const events = ()=>{
        itensLV0.forEach((i)=>i.addEventListener("click", handleClickItem(i)));
        if (isTablet) {
            toogle?.addEventListener("click", toogleMenu);
            document.querySelectorAll(".icon-back").forEach((i)=>i.addEventListener("click", backLevel));
        } else {
            sidebar.addEventListener("mouseenter", debounceFunction(toogleMenu, state.delay));
            sidebar.addEventListener("mouseout", toogleMenu);
            fundo.addEventListener("click", handleClickFundo);
        }
    // sidebar.addEventListener("mousemove", showLevelActive)
    };
    function init() {
        obj.forEach(createSubMenus);
        events();
        return this;
    }
    return {
        init: init,
        toogleMenu: toogleMenu
    };
}


function $896a6f4dd1484e0e$export$2e2bcd8739ae039() {
    const attr = document.querySelector("[data-secao]");
    if (!attr) return;
    const secao = GLOBAL.url.searchParams.get("secao");
    const wrapperSecao = document.querySelector(`[data-secao='${secao}']`);
    wrapperSecao && wrapperSecao.classList.remove("hidden");
}


function $e40099824fc4c4b2$export$2e2bcd8739ae039() {
    const { url: url } = GLOBAL;
    if (url.searchParams.has("mensagem_toastify")) {
        const mensagemToastify = url.searchParams.get("mensagem_toastify");
        Toastify({
            text: mensagemToastify,
            duration: 3000,
            position: "center"
        }).showToast();
        url.searchParams.set("mensagem_toastify", "");
        url.search = "";
        window.history.pushState({}, "", url);
    }
}


function $82bb7121020397f8$export$2e2bcd8739ae039() {
    const allSelects = [
        ...document.querySelectorAll("select[js-choices]")
    ]?.filter((select)=>!select.hasAttribute("js-no-choices"));
    if (!allSelects) return;
    const listOfChoices = [
        ...allSelects
    ].map((i)=>{
        const hasAttr = i.getAttribute("js-choices-props");
        const props = hasAttr ? JSON.parse(hasAttr) : {};
        const choicesObj = i.getAttribute("js-choices-obj");
        const opts = {
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: "Selecionar",
            noResultsText: "Nada Encontrado...",
            // choices: choicesObj
            ...props
        };
        const source = {
            choices: window[choicesObj]
        };
        const returnedTarget = choicesObj ? {
            ...opts,
            ...source
        } : opts;
        return GLOBAL.initChoices(i, returnedTarget);
    });
    window.listOfChoices = listOfChoices;
}


function $09ad54c0b85f5952$export$2e2bcd8739ae039() {
    const attr = "[js-tab]";
    const tabs = document.querySelectorAll(`.tabs${attr}`);
    if (!tabs.length) return;
    tabs.forEach((t)=>initTab(t));
    function initTab(tab) {
        console.log(tab);
        const collapses = tab.querySelectorAll(".tab-collapse");
        const tabItens = tab.querySelectorAll(".tabs-wrapper .tab-item");
        tabItens.forEach((t)=>{
            t.addEventListener("click", (e)=>{
                collapses.forEach((c)=>c.classList.remove("active"));
                tabItens.forEach((c)=>c.classList.remove("active"));
                t.classList.add("active");
                const att = e.currentTarget.dataset.tab;
                collapses.forEach((c)=>{
                    const attCollapse = c.getAttribute("data-tab");
                    console.log(attCollapse, att);
                    if (attCollapse == att) c.classList.add("active");
                });
            });
        });
    }
}


function $95f92ea9aeb91b34$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == "text" ? "password" : "text";
            if (input.type == "text") item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector(".password");
        buttonPass.addEventListener("click", handleEvent(div));
    });
}


function $e7b7600799de2c3c$export$2e2bcd8739ae039() {
    const attr = "[js-selecionar-colunas]";
    const els = document.querySelectorAll(attr);
    if (!els.length) return;
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    let colunasOcultas;
    let colunasInicialmenteOcultas;
    const showHideColun = (el, drop)=>(e)=>{
            const value = el.value;
            const table = document.querySelector("table");
            const tableColuns = table.querySelectorAll(`[data-reference='${value}']`);
            if (e.currentTarget.checked === false) tableColuns.forEach((i)=>i.classList.add("hidden"));
            else tableColuns.forEach((i)=>i.classList.remove("hidden"));
            colunasOcultas = [
                ...drop.querySelectorAll("input")
            ].filter((i)=>!i.checked).map((i)=>i.value).join();
            if (filtersOBJ) filtersOBJ["colunas_ocultas"] = colunasOcultas;
            else {
                filtersOBJ = {};
                filtersOBJ["colunas_ocultas"] = colunasOcultas;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            history.pushState(null, null, `${url.origin}${url.pathname}${newFilters}`);
        };
    if (filtersOBJ) {
        if (filtersOBJ["colunas_ocultas"]) colunasInicialmenteOcultas = filtersOBJ["colunas_ocultas"].split(",");
    }
    els.forEach((drop)=>{
        const inputs = drop.querySelectorAll("input");
        inputs.forEach((input)=>input.addEventListener("change", showHideColun(input, drop)));
        if (colunasInicialmenteOcultas) {
            const els = [
                ...drop.querySelectorAll(colunasInicialmenteOcultas.map((i)=>`input[value=${i}]`).join(","))
            ];
            els?.forEach((i)=>{
                i.checked = false;
                i.dispatchEvent(new Event("change"));
            });
        }
    });
}


function $e8298a482ccc12c8$export$2e2bcd8739ae039() {
    const attr = "js-table-ordenation";
    const els = document.querySelectorAll(`table[${attr}]`);
    if (!els.length) return;
    const url = GLOBAL.url;
    const filtersOBJ = GLOBAL.splitFilters(url.search);
    const order = filtersOBJ?.order;
    if (!order) return;
    const upOrDown = order?.includes("-") ? "down" : "up";
    console.log("FILTROS ATIVOS", filtersOBJ);
    els.forEach((table)=>{
        console.log(order);
        const th = table.querySelector(`thead [data-reference='${order.replace("-", "")}']`);
        console.log("th", th);
        th?.classList.add(upOrDown);
    });
}


function $325c2f552a563e5c$export$2e2bcd8739ae039() {
    const attr = "js-add-filter";
    const els = document.querySelectorAll(`[${attr}]`);
    if (!els.length) return;
    els.forEach((i)=>i.addEventListener("click", handleCallback));
    function handleCallback(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const filtro = target.getAttribute("js-add-filter")?.split(",");
        const [param, value] = filtro;
        const valueClean = value?.trim();
        const url = new URL(window.location);
        let filtersOBJ = GLOBAL.splitFilters(url.search);
        // const haveSameFilter = filtersOBJ ? filtersOBJ[param] : false
        if (filtersOBJ) {
            if (param === "order" && filtersOBJ.order?.replace("-", "") === valueClean) {
                console.log(target.classList.contains("up"));
                if (target.classList.contains("up")) filtersOBJ[param] = `-${valueClean}`;
                else filtersOBJ[param] = valueClean;
            } else filtersOBJ[param] = valueClean;
        } else {
            filtersOBJ = {};
            filtersOBJ[param] = value;
        }
        const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
        window.location.href = `${url.origin}${url.pathname}${newFilters}`;
    }
}


function $b25be962691391a4$export$2e2bcd8739ae039() {
    const attr = "js-table-search";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        const wrapper = i.closest(".input-container");
        const btn = wrapper.querySelector("button");
        btn.addEventListener("click", search(i));
        i.addEventListener("keyup", (e)=>{});
        if (!filtersOBJ) return;
        if (filtersOBJ["filter"]) i.value = decodeURIComponent(filtersOBJ["filter"]);
        else return;
    });
    function search(input) {
        return (e)=>{
            const target = e.currentTarget;
            if (filtersOBJ) filtersOBJ["filter"] = input.value;
            else {
                filtersOBJ = {};
                filtersOBJ["filter"] = input.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
    function clearSearch() {
        const el = document.querySelector("[js-table-clear-search]");
        const urlParams = new URLSearchParams(window.location.search);
        const filterParam = urlParams.get("filter");
        if (!el || !filterParam) return;
        const newUrl = location.href.replace(`&filter=${filterParam}`, "");
        el.classList.remove("hidden");
        el.setAttribute("href", newUrl);
    }
    clearSearch();
}


function $69f070a0264eae23$export$2e2bcd8739ae039() {
    const attr = "js-table-qnt";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["paginate_by"]) {
            const select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["paginate_by"]);
        }
    });
    function search(input) {
        return (e)=>{
            const target = e.currentTarget;
            const url = new URL(window.location);
            let filtersOBJ = GLOBAL.splitFilters(url.search);
            if (filtersOBJ) filtersOBJ["paginate_by"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["paginate_by"] = target.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
}


function $f319348b79f0c71d$export$2e2bcd8739ae039() {
    const attr = "js-table-recentes";
    const els = document.querySelectorAll(`[${attr}]`);
    const url = new URL(window.location);
    let filtersOBJ = GLOBAL.splitFilters(url.search);
    if (!els.length) return;
    els.forEach((i)=>{
        i.addEventListener("change", search(i));
        if (!filtersOBJ) return;
        if (filtersOBJ["order"]) {
            const select = GLOBAL.getChoicesActive(i.id, listOfChoices);
            select.setChoiceByValue(filtersOBJ["order"]);
        }
    });
    function search(input) {
        return (e)=>{
            const url = new URL(window.location);
            let filtersOBJ = GLOBAL.splitFilters(url.search);
            const target = e.currentTarget;
            if (filtersOBJ) filtersOBJ["order"] = target.value;
            else {
                filtersOBJ = {};
                filtersOBJ["order"] = target.value;
            }
            const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ);
            window.location.href = `${url.origin}${url.pathname}${newFilters}`;
        };
    }
}


function $1f18f9aaaa76016c$export$2e2bcd8739ae039() {
    const body = document.body;
    const btnOpenNotification = document.querySelector("[js-notification-open]");
    const sidebarNotification = document.querySelector(".alertas");
    let state = {
        open: false,
        delay: 150
    };
    const { isTablet: isTablet, debounceFunction: debounceFunction } = GLOBAL;
    const toggleSidebarNotification = (e)=>{
        state.open = true;
        body.classList.remove("notification-closed");
        if (state.open) // body.classList.add('notification-hover')
        body.classList.add("alerta-aberto");
        else {
            body.classList.add("notification-closed");
            // body.classList.remove('notification-hover')
            body.classList.remove("alerta-aberto");
        }
    };
    const toggleOnHoverSideBar = (e)=>{
        //funcao do jquery que me da mais certeza c o menu esta aberto ou n
        if (!isTablet) state.open = $(sidebarNotification).is(":hover");
        if (state.open) {
            body.classList.add("notification-hover");
            body.classList.add("alerta-aberto");
        } else {
            body.classList.remove("notification-hover");
            body.classList.remove("alerta-aberto");
            if (isTablet) state.open = true;
        }
    };
    const closeNotificationBar = ({ target: target })=>{
        if (target.classList.contains("fundo-alerta") || target.hasAttribute("js-notification-close")) {
            body.classList.remove("alerta-aberto");
            // body.classList.remove('notification-hover')
            body.classList.add("notification-closed");
            open.state = false;
        }
    };
    document.addEventListener("click", closeNotificationBar);
    btnOpenNotification && btnOpenNotification.addEventListener("click", debounceFunction(toggleSidebarNotification, state.delay));
// if (isTablet) {
//   sidebarNotification.addEventListener("click", toggleOnHoverSideBar)
// } else {
//   sidebarNotification && sidebarNotification.addEventListener('mouseenter', debounceFunction(toggleOnHoverSideBar, state.delay))
//   sidebarNotification && sidebarNotification.addEventListener("mouseout", toggleOnHoverSideBar)
// }
}


function $e6791d1b59063392$export$2e2bcd8739ae039(form, formulas) {
    function mudavalores(formulas) {
        //pego cada objeto de formula
        const relacaoFormulas = Object.values(formulas).map((value)=>value);
        //jogo no elemento o resultado da formula
        relacaoFormulas.map((i)=>i.el.innerHTML = i.formula());
    }
    //rodo inicialmente pra mudar o valor
    mudavalores(formulas);
    //adiciono o change pra rodar a mudanca de valores
    form.addEventListener("change", ()=>mudavalores(formulas));
}


function $f54a5961dd25c995$export$2e2bcd8739ae039(_loader) {
    const textDefault = [
        "Aguarde, estamos enviando seus dados",
        "Mais um pouco...",
        "Quase l\xe1..."
    ];
    const loaderEL = document.querySelector(".loader--container") || _loader;
    const pEl = loaderEL.querySelector("p");
    let interval;
    /**
	* @param {array} opcional | recebe um array de objetos para ser mostrado 
	*/ function show(options) {
        loaderEL.dataset.active = "true";
        let atual = 0;
        const obj = {
            textos: textDefault,
            time: 8000,
            ...options
        };
        $(pEl).text(obj.textos[atual]);
        interval = setInterval(function() {
            $(pEl).fadeOut(function() {
                if (atual > obj.textos.length) atual = 0;
                $(pEl).text(obj.textos[atual]).fadeIn();
                atual = atual + 1;
            });
        }, obj.time);
        return this;
    }
    function hide() {
        loaderEL.dataset.active = "false";
        clearInterval(interval);
        pEl.innerText = "";
        return this;
    }
    return {
        show: show,
        hide: hide
    };
}


function $bede6529b3b5a8e5$export$2e2bcd8739ae039() {
    const textToChange = document.querySelector(".card.estilo-form .header-card .titulo p");
    const urlString = window.location.href;
    if (!textToChange) return;
    urlString.indexOf("update") != -1 && (textToChange.innerText = "Editar Cadastro");
}


function $16548eeb230e89e4$export$2e2bcd8739ae039() {
    const cardsToAnimate = document.querySelectorAll("[js-animate]");
    gsap.set(cardsToAnimate, {
        autoAlpha: 0,
        transition: "initial",
        y: 15
    });
    document.addEventListener("DOMContentLoaded", ()=>{
        gsap.to(cardsToAnimate, {
            autoAlpha: 1,
            stagger: 0.10,
            y: 0,
            delay: .2
        });
    });
}


(0, $965533ac84b5bf59$export$2e2bcd8739ae039)();
(0, $33e222e22d670651$export$2e2bcd8739ae039)();
(0, $f231b21555063952$export$2e2bcd8739ae039)();
(0, $f96a0b47b65ca3bd$export$2e2bcd8739ae039)();
(0, $d1667b4cd6b81e3c$export$2e2bcd8739ae039)() // Faz as implementações relacionadas aos inlines
;
(0, $97753764ffa51793$export$2e2bcd8739ae039)() // muda class ativa nos inputs
;
(0, $a6fa111a019cef8a$export$2e2bcd8739ae039)();
(0, $1f18f9aaaa76016c$export$2e2bcd8739ae039)();
(0, $896a6f4dd1484e0e$export$2e2bcd8739ae039)() //mostra elemento de acordo com parametro na url
;
(0, $e40099824fc4c4b2$export$2e2bcd8739ae039)();
(0, $82bb7121020397f8$export$2e2bcd8739ae039)() //inicia bibiloteca Choices.js
;
(0, $09ad54c0b85f5952$export$2e2bcd8739ae039)();
(0, $95f92ea9aeb91b34$export$2e2bcd8739ae039)();
(0, $325c2f552a563e5c$export$2e2bcd8739ae039)() //adiona um filtro na url e recarrega
;
//table
(0, $e7b7600799de2c3c$export$2e2bcd8739ae039)() //show hide coluns
;
(0, $e8298a482ccc12c8$export$2e2bcd8739ae039)() // ordenacao ao clicar na thead
;
(0, $b25be962691391a4$export$2e2bcd8739ae039)() //Busca da tabela basica
;
(0, $69f070a0264eae23$export$2e2bcd8739ae039)() //quantidade de items vcisiveis na tabela
;
(0, $f319348b79f0c71d$export$2e2bcd8739ae039)() //ordena por id maior ou menor
;
(0, $bede6529b3b5a8e5$export$2e2bcd8739ae039)();
(0, $16548eeb230e89e4$export$2e2bcd8739ae039)();
const $b6219fad654ae86f$var$menuObject = (0, $a6fa111a019cef8a$export$2e2bcd8739ae039)(subMenuItens);
if ($b6219fad654ae86f$var$menuObject) {
    const menu = $b6219fad654ae86f$var$menuObject.init();
    window.menu = menu;
}
window.initAccordion = (0, $965533ac84b5bf59$export$2e2bcd8739ae039);
window.mudaValoresDeAcordoComFormula = (0, $e6791d1b59063392$export$2e2bcd8739ae039);
window.myLoader = (0, $f54a5961dd25c995$export$2e2bcd8739ae039);
document.addEventListener("DOMContentLoaded", ()=>{
    document.body.classList.add("DOMContentLoaded");
});

})();
//# sourceMappingURL=main.js.map
